import React from "react";

import { Props } from "./types";
import styles from "./styles.scss";

function Loader(props: Props) {
  return <div className={styles.loader} />;
}

export { Loader };
